import colonyAPI from '@/api/colony';
import * as types from './mutation-types';

export default {
  getCampaignRules({ commit }, campaignId) {
    commit(types.GET_RULES_REQUEST);

    colonyAPI
      .get('rules/', { params: { campaign_id: campaignId } })
      .then(response => commit(types.GET_RULES_SUCCESS, response.data))
      .catch(error => commit(types.GET_RULES_FAILURE, error));
  },

  getRule({ commit }, ruleId) {
    commit(types.GET_RULE_REQUEST);

    colonyAPI
      .get(`rules/${ruleId}/`)
      .then(response => commit(types.GET_RULE_SUCCESS, response.data))
      .catch(error => commit(types.GET_RULE_FAILURE, error));
  },

  createRule({ commit }, rule) {
    commit(types.CREATE_RULE_REQUEST);
    colonyAPI
      .post('rules/', rule)
      .then(response => commit(types.CREATE_RULE_SUCCESS, response.data))
      .catch(error => commit(types.CREATE_RULE_FAILURE, error));
  },

  updateRule({ commit, dispatch }, rule) {
    commit(types.UPDATE_RULE_REQUEST);
    colonyAPI
      .put(`rules/${rule.id}/`, rule)
      .then(() => {
        commit(types.UPDATE_RULE_SUCCESS);
        dispatch('getCampaignRules', rule.campaign);
      })
      .catch(error => commit(types.UPDATE_RULE_FAILURE, error));
  },

  deleteRule({ commit }, payload) {
    commit(types.DELETE_RULE_REQUEST);

    colonyAPI
      .delete(`rules/${payload.rule.id}/`)
      .then(() => commit(types.DELETE_RULE_SUCCESS, payload.ruleIndex))
      .catch(error => commit(types.DELETE_RULE_FAILURE, error));
  },

  getRuleFields({ commit }) {
    commit(types.GET_RULE_FIELDS_REQUEST);

    colonyAPI
      .get('rules/fields/')
      .then(response => commit(types.GET_RULE_FIELDS_SUCCESS, response.data))
      .catch(error => commit(types.GET_RULE_FIELDS_FAILURE, error));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/rules/actions.js